import { useMemo } from 'react'

import { useListAssessments, useListOngoingAssessments } from '@/api/assessments.hook'

export const useCompanyHasAssessments = (companyId: string) => {
  const { assessments, isLoading: isAssessmentsLoading } = useListAssessments(companyId)
  const { ongoingAssessments, error, isPending } = useListOngoingAssessments(companyId)

  const pastAssessments = useMemo(() => {
    const linkedPastAssessmentIds = new Set(
      ongoingAssessments
        .filter((assessment) => assessment.pastAssessmentId)
        .map((assessment) => assessment.pastAssessmentId) || [],
    )

    return assessments.filter((assessment) => !linkedPastAssessmentIds.has(assessment.id))
  }, [assessments, ongoingAssessments])

  let hasAssessments = false,
    hasNoAssessment = false,
    hasOngoingAssessments = false

  if (isAssessmentsLoading || isPending || error) {
    if (error) {
      console.error('Error fetching assessments:', error)
    }
    return {
      hasNoAssessment,
      hasOngoingAssessments,
      noOngoingAssessments: 0,
      noPastAssessments: 0,
      hasOngoingAssessmentWithProject: () => false,
    }
  }

  hasAssessments = assessments.length > 0
  hasOngoingAssessments = ongoingAssessments.length > 0
  hasNoAssessment = !hasAssessments && !hasOngoingAssessments

  const hasOngoingAssessmentWithProject = (projectId: string) => {
    return ongoingAssessments.some((assessment) => assessment.projectId === projectId)
  }

  return {
    hasNoAssessment,
    hasOngoingAssessments,
    noOngoingAssessments: ongoingAssessments.length || 0,
    noPastAssessments: pastAssessments.length || 0,
    hasOngoingAssessmentWithProject,
  }
}
